import { render, staticRenderFns } from "./anamneseTexto.vue?vue&type=template&id=258f1e85"
import script from "./anamneseTexto.vue?vue&type=script&lang=js"
export * from "./anamneseTexto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports